import React from 'react';

class Loading extends React.Component{


    render(){

        return (
            <div className={"esd-loading "+this.props.classes}><span>{(this.props.msg || '')}</span></div>
        )
    }
}

export default Loading;